import React, { createContext, useContext, useMemo, useReducer } from 'react';
import type { State } from './types';
import type { Mutation } from './mutations';
import { reducer } from './mutations';
import { type Computed, useComputed } from './computed';

export interface PeopleStore {
  state: State;
  dispatch: React.Dispatch<Mutation>;
  computed: Computed;
}

const PeopleContext = createContext<PeopleStore>({} as PeopleStore);

const initialState: State = {
  data: [],
  count: 0,
  loaded: false,
};

export function PeopleStoreProvider({
  children,
}: {
  children: React.ReactElement;
}) {
  const [state, dispatch] = useReducer(reducer, initialState);
  const computed = useComputed(state);
  const props = useMemo(
    () => ({
      state,
      dispatch,
      computed,
    }),
    [state, dispatch, computed],
  );

  return React.createElement(
    PeopleContext.Provider,
    { value: props },
    children,
  );
}

export function usePeopleStore() {
  return useContext(PeopleContext);
}
